import { useState, useEffect, useMemo } from "react";

import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import Joi from "joi-browser";
import { getLifecycleCbs } from "./common/lifecycleCbs";
import { CampaignTypeIcons } from "../../common/CampaignTypeIcons";
import { CAMPAIGN_TYPE } from "../../BulkCampaigns/BulkCampaignCreate";
import { getFollowUpSettings } from "./common/utils";

const template = [
  {
    name: "followUpDelay",
    label: "Follow-up after (hours) *",
    type: "text",
  },
  {
    name: "followUpMessage",
    label: "Message *",
    type: "textArea",
    style: { height: "200px", fontSize: "13px" },
  },
];

const schema = {
  followUpDelay: Joi.number()
    .required()
    .label("Follow-up after (hours)")
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.code) {
          case "number.base":
            err.message = "Follow-up after (hours) should be a number field";
            break;
          case "any.required":
            err.message = "Follow-up after (hours) is required";
            break;
        }
      });
      return errors;
    }),
  followUpMessage: Joi.string().required().max(480).label("message"),
};

export default function FollowUpSms({
  followUpSettings,
  setFollowUpSettings,
  itemIndexForEdit,
  handleSave,
  open,
  onClose,
  mode,
}) {
  const [inputField] = useState(
    getFollowUpSettings(
      mode,
      itemIndexForEdit,
      followUpSettings,
      CAMPAIGN_TYPE.SMS
    )
  );
  const [loading, setLoading] = useState(false);

  const { data, validate, handleChange, error } = useForm(inputField, schema);

  const handleSubmit = async () => {
    let updatedFollowUps = [];

    const { followUpDelay, followUpMessage } = data;

    const updatedData = {
      followUpDelay,
      followUpMessage,
      whatsAppFollowUp: {
        templateName: "",
        language: "",
      },
    };

    if (mode === "add") {
      const addedFollowUp = { ...updatedData, order: followUpSettings.length };
      updatedFollowUps = [...followUpSettings, addedFollowUp];
    }

    if (mode === "edit") {
      const editedFollowUp = { ...updatedData, order: itemIndexForEdit };

      updatedFollowUps = followUpSettings.toSpliced(
        itemIndexForEdit,
        1,
        editedFollowUp
      );
    }

    const onInit = () => setLoading(true);

    const onError = () => setLoading(false);

    const onSuccess = () => {
      setFollowUpSettings(updatedFollowUps);
      setLoading(false);
      onClose();
    };
    const lifecycleCbs = getLifecycleCbs(onInit, onSuccess, onError);

    handleSave({ followUpSettings: updatedFollowUps }, lifecycleCbs);
  };

  const isSaveDisabled =
    validate(data, schema) || Boolean(Object.keys(error).length);

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        <div className="flex gap-x-2">
          {CampaignTypeIcons[CAMPAIGN_TYPE.SMS]}
          Follow-Up SMS
        </div>
      </DialogTitle>
      <DialogBody>
        <Form
          data={data}
          handleChange={handleChange}
          template={template}
          error={error}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          disabled={isSaveDisabled}
          loading={loading}
          onClick={handleSubmit}
        >
          {mode === "edit" ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
